// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-769ee70b]{margin:0}.title[data-v-769ee70b]{font-size:14px;line-height:18px;margin:12px 0}.bold[data-v-769ee70b]{font-family:SFProDisplay-Medium,sans-serif}", ""]);
// Exports
module.exports = exports;
